<template>
  <div
    v-loading="$wait.is(['updateNextActionWait', 'getNextActionsWait', 'doneNextActionWait'])"
    class="draft-item-area"
  >
    <div
      v-for="dfaftItem in draftItems"
      :key="`draft-${dfaftItem.id}`"
      class="draft-item-task"
    >
      <DirectMail
        v-if="isDraftDirectMail(dfaftItem)"
        :direct-mail="dfaftItem"
        @after-delete="handleDirectMailReload"
        @click="() => handleDirectMailConfirm(dfaftItem)"
      />
      <NextActionSuggestion
        v-else
        :next-action-suggestion="dfaftItem"
        @click="() => handleNextActionSuggestionClick(dfaftItem)"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { DraftDirectMail, NextActionSuggestion as TNextActionSuggestion } from '@/api/openapi';
import { isRelatedToSequence } from '@/composable/user/directMail/direct-mail';
import DirectMail from './task/DirectMail.vue';
import NextActionSuggestion from './task/NextActionSuggestion.vue';

// NOTE: directMailしか含まれていない前提の構造なので、objectの種類が増えた時は修正する
type TProps = {
  draftItems: DraftDirectMail[] | TNextActionSuggestion[];
};
type TEmits = {
  'click:sequenceAction': [sequenceInstanceId: number];
  'click:directMailConfirm': [directMail: DraftDirectMail];
  'click:nextActionSuggestion': [nextActionSuggestion: TNextActionSuggestion];
  'afterDeleteDirectMail': [];
};

defineProps<TProps>();

const emit = defineEmits<TEmits>();

const handleDirectMailConfirm = (directMail: DraftDirectMail) => {
  if (isRelatedToSequence(directMail)) {
    emit('click:sequenceAction', directMail.sequenceInstanceId);
  } else {
    emit('click:directMailConfirm', directMail);
  }
};
const handleNextActionSuggestionClick = (nextActionSuggestion: TNextActionSuggestion) => {
  emit('click:nextActionSuggestion', nextActionSuggestion);
};
const handleDirectMailReload = () => { emit('afterDeleteDirectMail'); };

const isDraftDirectMail = (draftItem: DraftDirectMail | TNextActionSuggestion): draftItem is DraftDirectMail => {
  return 'sendToAddress' in draftItem;
};
</script>
